import AbstractAPI from './AbstractAPI';

export default class AuthAPI extends AbstractAPI {
  getUserAttributes() {
    return this.get('user-attributes');
  }
}
